"use strict";

/**
 * @description Initializes the "password meets requirements" functionality
*/

function fieldRequirements() {
    const requirementsList = Array.from(document.querySelectorAll(".js-input-message-requirement"));

    if (requirementsList) {
        requirementsList.forEach(item => {
            let input = item.parentNode.querySelector("input");
            let regex = item.getAttribute("data-regex") || "[]";

            if ($(item).css("display") == "block") {
                input.classList.add("c-input__with-requirements");
            }

            input.addEventListener("input", function () {
                let inputValue = this.value;
                inputValue.match(new RegExp(regex)) ?
                    item.classList.add("selected") :
                    item.classList.remove("selected");
            });

            input.value.match(new RegExp(regex)) ?
                item.classList.add("selected") :
                item.classList.remove("selected");
        });
    }
}

module.exports = fieldRequirements;
